import { render, staticRenderFns } from "./InfoValuesBlock.vue?vue&type=template&id=55be8fbe&scoped=true&"
import script from "./InfoValuesBlock.vue?vue&type=script&lang=js&"
export * from "./InfoValuesBlock.vue?vue&type=script&lang=js&"
import style0 from "./InfoValuesBlock.vue?vue&type=style&index=0&id=55be8fbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55be8fbe",
  null
  
)

export default component.exports